<mat-form-field appearance="outline" class="text-area h-100 w-100">
  <mat-label class="registration-address"
    >Vehicle Registration Address</mat-label
  >
  <textarea
    matInput
    formControlName="vehicle_registration_address"
    appNoSpace
    minlength={{minLenth}}
    appRemoveNewlines
  ></textarea>
  <mat-error
    *ngIf="
      vehilceRegistrationForm.controls[
        'vehicle_registration_address'
      ]?.hasError('required')
    "
  >
    This is required field
  </mat-error>
  <mat-error
    *ngIf="
      vehilceRegistrationForm.controls[
        'vehicle_registration_address'
      ]?.hasError('minlength')
    "
  >
    Cannot be less than {{minLenth}} Characters
  </mat-error>
  <mat-error
    [hidden]="isNotShowErrorMsg"
    *ngIf="
      vehilceRegistrationForm.controls[
        'vehicle_registration_address'
      ]?.hasError('maxlength')
    "
  >
    Cannot be more than {{ maxLength }} Characters
  </mat-error>
</mat-form-field>
<div
  *ngIf="isNotShowErrorMsg"
  class="text-danger error"
  [ngClass]="isNotShowErrorMsg ? 'mb-3 ms-3' : ''"
>
  Cannot be more than {{ maxLength }} Characters
</div>
